var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellput1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22H61.5V17.5H31.5L7 42.5V48.5L34 22Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 34L7 42.2648V48.5L21.5 34H15.5Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellput1);
export default __webpack_public_path__ + "static/media/sell put1.2242dad7addaafb4a8a1094ad3c30542.svg";
export { ForwardRef as ReactComponent };